export const settingsRootConfig = ({ client }) => ({
  HTTPMethod: "get",
  path: `/settings/${client}/settings.json`,
  headers: {},
  body: {},
});
